import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierInfoPage.title',
    defaultMessage: 'Information & Requirements',
  },
  subtitle: {
    id: 'containers.SupplierInfoPage.subtitle',
    defaultMessage: 'Please reference this collection of guides and documents, working with us.',
  },
  techSpecsTitle: {
    id: 'containers.SupplierInfoPage.techSpecs.title',
    defaultMessage: 'Tech Specs',
  },
  techSpecsBody: {
    id: 'containers.SupplierInfoPage.techSpecs.body',
    defaultMessage: '',
  },
  paymentTermsTitle: {
    id: 'containers.SupplierInfoPage.paymentTerms.title',
    defaultMessage: 'Payment Terms',
  },
  paymentTermsBody: {
    id: 'containers.SupplierInfoPage.paymentTerms.body',
    defaultMessage: '',
  },
  troubleshootingTitle: {
    id: 'containers.SupplierInfoPage.troubleshooting.title',
    defaultMessage: 'Troubleshooting',
  },
  troubleshootingBody: {
    id: 'containers.SupplierInfoPage.troubleshooting.body',
    defaultMessage: '',
  },
  demoSpecsTitle: {
    id: 'containers.SupplierInfoPage.demoSpecs.title',
    defaultMessage: 'Demo Requirements',
  },
  demoSpecsBody: {
    id: 'containers.SupplierInfoPage.demoSpecs.body',
    defaultMessage: '',
  },
  demoScriptTitle: {
    id: 'containers.SupplierInfoPage.demoScript.title',
    defaultMessage: 'Demo Manuscript',
  },
  demoScriptBody: {
    id: 'containers.SupplierInfoPage.demoScript.body',
    defaultMessage: '',
  },
  fileFormatTitle: {
    id: 'containers.SupplierInfoPage.fileFormat.title',
    defaultMessage: 'File Format Settings',
  },
  fileFormatBody: {
    id: 'containers.SupplierInfoPage.fileFormat.body',
    defaultMessage: '',
  },
  usageTermsTitle: {
    id: 'containers.SupplierInfoPage.usageTerms.title',
    defaultMessage: 'Advertising-workflow',
  },
  usageTermsBody: {
    id: 'containers.SupplierInfoPage.usageTerms.body',
    defaultMessage: "## Registration of Media Usage for a Task\nFor advertising orders where the client has requested paid media usage of the recordings, we will send you two separate tasks: one for the actual voiceover recording and the other for media usage. Under ‘Type’ in each task, you can see which type of task it is.\n### The Voiceover Task Will Contain:\n- All the information you need regarding the recording itself, such as file format, product information, style brief, reference material, and/or word count.\n- This order is not intended for public view, and the fee shown does not include any paid media usage.\n- You will be required to upload the final file for this task.\n### The Usage Task Will Contain:\n- Details about the media, territory, and period, and the fee shown is exclusively for the paid media usage requested by the client.\n- When receiving a usage task on our platform, you will be able to view the usage terms requested by the client for your recording.\n- By approving this task, you acknowledge and accept these terms.\n### Please Note the Following Conditions:\n- The client retains the right to cancel within 14 days from the date VoiceArchive sends the final files to the client.\n- This cancellation period also applies if additional media usage has been approved by the voice talent.\n",
  }
})
